import React from 'react';
import './PickerField.css';

const PickerField = ({value, placeholder, onClick}) => {
	return (
		<div className={`PickerField ${value ? 'has-value' : 'empty'}`} onClick={onClick}>
			<span className="PickerField-value">{value || 'None'}</span>
			<span className="PickerField-placeholder">{placeholder}</span>
		</div>
	);
};

export default PickerField;



// WEBPACK FOOTER //
// ./src/profile/PickerField.js